import { render, staticRenderFns } from "./insurancePhoto.vue?vue&type=template&id=3d08bf04"
import script from "./insurancePhoto.vue?vue&type=script&lang=js"
export * from "./insurancePhoto.vue?vue&type=script&lang=js"
import style0 from "./insurancePhoto.vue?vue&type=style&index=0&id=3d08bf04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports